<template>
	<div
		class="modal fade"
		id="addKeywords"
		tabindex="-1"
		role="dialog"
		aria-labelledby="addEditCampaignGroup"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content campaign-g-addedit">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">Add Keywords</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<!-- <h2 class="text-center">Editing Campaign Group</h2> -->
					<div class="form-container">
						<!-- form start-->
						<form>
							<div class="row">
								<div class="col">
									<div class="form-group">
										<label>
											<input type="checkbox" v-on:click="hideShowMsg" v-model="isBoard"> Broad
										</label>
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text" id="basic-addon1">$</span>
											</div>
											<input
												type="number"
												v-model="boardBidAmount"
												placeholder="Bid Amount"
												class="form-control"
												:class="{ 'is-invalid': submitted && !checkBoardAmount }"
											>
											<span
												v-if="submitted && !checkBoardAmount"
												class="invalid-feedback"
											>Enter bid amount to proceed</span>
										</div>
									</div>
								</div>
								<div class="col">
									<div class="form-group">
										<label>
											<input type="checkbox" v-on:click="hideShowMsg" v-model="isPhrase"> Phrase
										</label>
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text" id="basic-addon1">$</span>
											</div>
											<input
												type="number"
												v-model="phraseBidAmount"
												placeholder="Bid Amount"
												class="form-control"
												:class="{ 'is-invalid': submitted && !checkPhraseAmount }"
											>
											<span
												v-if="submitted && !checkPhraseAmount"
												class="invalid-feedback"
											>Enter bid amount to proceed</span>
										</div>
									</div>
								</div>
								<div class="col">
									<div class="form-group">
										<label>
											<input type="checkbox" v-on:click="hideShowMsg" v-model="isExact"> Exact
										</label>
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text" id="basic-addon1">$</span>
											</div>
											<input
												type="number"
												v-model="exactBidAmount"
												placeholder="Bid Amount"
												class="form-control"
												:class="{ 'is-invalid': submitted && !checkExactAmount }"
											>
											<span
												v-if="submitted && !checkExactAmount"
												class="invalid-feedback"
											>Enter bid amount to proceed</span>
										</div>
									</div>
								</div>
							</div>
							<div class="form-group" style="margin:3px">
								<label v-if="productList && productList.length">
									<input type="checkbox" v-model="importKeyword"> Import From Product
								</label>
							</div>
							<div class="form-group" style="margin:3px">
								<label>
									<input type="file"> Import CSV File
								</label>
							</div>
							<div
								v-if="importKeyword && importKeywordSpinner"
								class="spinner-border"
								style="margin:auto;display:block;margin-top:60px"
							></div>
							<div v-else class="form-group">
								<label>Keywords</label>
								<textarea
									v-model="keywordArray"
									class="form-control"
									style="height:75px;"
									v-on:click="hideMsgKeyword"
								></textarea>
							</div>
							<div v-if="showMsg" style="color : red">
								<p>Select the bid type to proceed</p>
							</div>
							<div v-if="showMsgKeyword" style="color : red">
								<p>Enter keyword to save</p>
							</div>
                            <div v-if="showEmptyKeywordFromImport" style="color : red">
								<p>No keyword to import</p>
							</div>
						</form>
						<!-- form end-->
					</div>
				</div>
				<div class="modal-footer">
					<button
						type="button"
						class="btn btn-secondary"
						data-dismiss="modal"
						@click="resetAllValues()"
					>Cancel</button>
					<button type="button" class="btn btn-primary" @click="saveKeywordToCampaign()">Save</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AddCampaignKeywordModal",
		data() {
			return {
				isBoard: false,
				isPhrase: false,
				isExact: false,
				boardBidAmount: "",
				phraseBidAmount: "",
				exactBidAmount: "",
				keywordArray: "",
				submitted: false,
				importKeyword: false,
				importKeywordSpinner: true,
				importedKeywordList: [],
				showMsg: false,
                showMsgKeyword: false,
                showEmptyKeywordFromImport: false
			};
		},
		props: {
			selectedKeyword: {
				type: Object
			},
			productList: {
				type: Array
			},
			productIdList: {
				type: Array
			}
		},
		computed: {
			checkBoardAmount() {
				//this.showMsg = false;
				//this.showMsgKeyword = false;
				let demical = /^\d+(,\d{3})*(\.\d{1,2})?$/;
				if (this.isBoard) {
					if (this.boardBidAmount.match(demical)) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			},
			checkPhraseAmount() {
				// this.showMsg = false;
				// this.showMsgKeyword = false;
				let demical = /^\d+(,\d{3})*(\.\d{1,2})?$/;
				if (this.isPhrase) {
					if (this.isPhrase && this.phraseBidAmount.match(demical)) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			},
			checkExactAmount() {
				// this.showMsg = false;
				// this.showMsgKeyword = false;
				let demical = /^\d+(,\d{3})*(\.\d{1,2})?$/;
				if (this.isExact) {
					if (this.isExact && this.exactBidAmount.match(demical)) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			}
		},
		watch: {
			selectedKeyword() {
				//this.showMsgKeyword = false;
				if (this.selectedKeyword) {
					let vm = this;
					if (this.selectedKeyword.keyword) {
						this.keywordArray = this.selectedKeyword.keyword.join("\n");
					}
					if (this.selectedKeyword.bids) {
						this.selectedKeyword.bids.forEach(element => {
							if (element.type.toLowerCase() == "board") {
								vm.isBoard = true;
								vm.boardBidAmount = element.bid + "";
							} else if (element.type.toLowerCase() == "phrase") {
								vm.isPhrase = true;
								vm.phraseBidAmount = element.bid + "";
							} else if (element.type.toLowerCase() == "exact") {
								vm.isExact = true;
								vm.exactBidAmount = element.bid + "";
							}
						});
					}
				}
			},
			importKeyword() {
				let vm = this;
				this.showMsgKeyword = false;
				this.keywordArray = "";
				if (this.importKeyword) {
					var payload = { id: this.productIdList };
					vm.$store
						.dispatch("campaign/importKeywordFromProduct", payload)
						.then(res => {
							// let response = res.keywordjson.keyword
							if (JSON.parse(res[0].keywordjson) == null) {
                                this.showEmptyKeywordFromImport = true;
                                this.importKeyword = false;
							} else {
								for (var i = 0; i < res.length; i++) {
									for (
										var j = 0;
										j < JSON.parse(res[i].keywordjson).length;
										j++
									) {
										for (
											var k = 0;
											k <
											JSON.parse(res[i].keywordjson)[j]
												.keyword.length;
											k++
										) {
											if (
												i == res.length - 1 &&
												j ==
													JSON.parse(res[i].keywordjson)
														.length -
														1 &&
												k ==
													JSON.parse(res[i].keywordjson)[
														j
													].keyword.length -
														1
											) {
												vm.keywordArray =
													vm.keywordArray +
													JSON.parse(res[i].keywordjson)[
														j
													].keyword[k];
											} else {
												vm.keywordArray =
													vm.keywordArray +
													JSON.parse(res[i].keywordjson)[
														j
													].keyword[k] +
													"\n";
											}
										}
									}
								}
							}
							vm.importKeywordSpinner = false;
						});
				} else {
					this.keywordArray = "";
					this.importKeywordSpinner = true;
				}
			}
		},
		methods: {
			hideMsgKeyword() {
                this.showMsgKeyword = false;
                this.showEmptyKeywordFromImport = false;
			},
			hideShowMsg() {
				this.showMsg = false;
			},
			saveKeywordToCampaign() {

				this.submitted = true;
				let bids = [];
				if (this.isBoard) {
					this.showMsg = false;
					if (this.checkBoardAmount) {
						let board = {
							bid: parseFloat(this.boardBidAmount),
							type: "Board"
						};
						bids.push(board);
					} else {
						return;
					}
				}
				if (this.isPhrase) {
					this.showMsg = false;
					if (this.checkPhraseAmount) {
						let phrase = {
							bid: parseFloat(this.phraseBidAmount),
							type: "Phrase"
						};
						bids.push(phrase);
					} else {
						return;
					}
				}
				if (this.isExact) {
					this.showMsg = false;
					if (this.checkExactAmount) {
						let exact = {
							bid: parseFloat(this.exactBidAmount),
							type: "Exact"
						};
						bids.push(exact);
					} else {
						return;
					}
				}
				if (
					(this.isBoard && this.checkBoardAmount) ||
					(this.isPhrase && this.checkPhraseAmount) ||
					(this.isExact && this.checkExactAmount)
				) {
					if (this.importKeyword) {
						var newKeywordObject = {
							keyword: this.keywordArray.split("\n"), //.replace(/\s/g, ' ')
							bids: bids
						};
					} else {
						var newKeywordObject = {
							keyword: this.keywordArray.split("\n"), //.replace(/\s/g, ' ')
							bids: bids
						};
					}
					if (
						this.selectedKeyword &&
						this.selectedKeyword.keywordIndex > -1
					) {
						newKeywordObject.keywordIndex = this.selectedKeyword.keywordIndex;
					}
					if (
						(this.newKeywordObject && this.newKeywordObject.length) ||
						this.keywordArray.length
					) {
						this.$emit("saveKeywordToCampaign", newKeywordObject);
						$("#addKeywords").modal("hide");
						this.resetAllValues();
					} else {
						this.showMsgKeyword = true;
					}
				} else {
					//    this.resetAllValues()
					//    $('#addKeywords').modal('hide')
					this.showMsg = true;
				}
			},
			resetAllValues() {
				this.$emit("resetSelectedItem");
				this.isBoard = false;
				this.isPhrase = false;
				this.isExact = false;
				this.phraseBidAmount = "";
				this.exactBidAmount = "";
				this.boardBidAmount = "";
				this.keywordArray = "";
				this.submitted = false;
				this.importKeyword = false;
				this.importKeywordSpinner = true;
				this.showMsgKeyword = false;
                this.showMsg = false;
                this.showEmptyKeywordFromImport = false;
			}
		}
	};
</script>

<style lang="scss">
</style>
